import { ACCENT_CYAN, HERO_CHART, NOPING_GREEN } from '../constants';

export function HeroPingViz() {
  return (
    <div className='relative mx-auto h-36 w-full max-w-2xl md:h-48'>
      <div className='absolute inset-0 opacity-10'>
        {Array.from({ length: 8 }).map((_, i) => (
          <div key={`h-${i}`} className='absolute w-full border-t' style={{ top: `${(i + 1) * 12.5}%`, borderColor: `${ACCENT_CYAN}30` }} />
        ))}
        {Array.from({ length: 12 }).map((_, i) => (
          <div key={`v-${i}`} className='absolute h-full border-s' style={{ left: `${(i + 1) * 8.33}%`, borderColor: `${ACCENT_CYAN}30` }} />
        ))}
      </div>

      <svg viewBox='0 0 600 200' className='relative z-10 size-full' preserveAspectRatio='none'>
        <defs>
          <linearGradient id='heroFill' x1='0' y1='0' x2='0' y2='1'>
            <stop offset='0%' stopColor={ACCENT_CYAN} stopOpacity='0.25' />
            <stop offset='100%' stopColor={ACCENT_CYAN} stopOpacity='0' />
          </linearGradient>
          <linearGradient id='heroFillOsc' x1='0' y1='0' x2='0' y2='1'>
            <stop offset='0%' stopColor={NOPING_GREEN} stopOpacity='0.15' />
            <stop offset='100%' stopColor={NOPING_GREEN} stopOpacity='0' />
          </linearGradient>
          <filter id='glow'>
            <feGaussianBlur stdDeviation='3' result='blur' />
            <feMerge>
              <feMergeNode in='blur' />
              <feMergeNode in='SourceGraphic' />
            </feMerge>
          </filter>
          <filter id='glowGreen'>
            <feGaussianBlur stdDeviation='2' result='blur' />
            <feMerge>
              <feMergeNode in='blur' />
              <feMergeNode in='SourceGraphic' />
            </feMerge>
          </filter>
        </defs>

        <path d={HERO_CHART.highPingPath} fill='none' stroke='#FF4444' strokeWidth='2' opacity='0.6' className='animate-draw-hero' />
        <path d='M250,28 C280,30 300,80 320,150 Q340,175 360,178' fill='none' stroke={ACCENT_CYAN} strokeWidth='2.5' filter='url(#glow)' className='animate-draw-hero-delayed' />

        <g className='animate-fill-hero' style={{ opacity: 0 }}>
          <path d='M360,178 L380,176 L400,179 L420,175 L440,178 L460,176 L480,179 L500,175 L520,178 L540,176 L560,179 L580,176 L600,178' fill='none' stroke={NOPING_GREEN} strokeWidth='2.5' filter='url(#glowGreen)' className='hero-osc-line' />
          <path d='M360,178 L380,176 L400,179 L420,175 L440,178 L460,176 L480,179 L500,175 L520,178 L540,176 L560,179 L580,176 L600,178 L600,200 L360,200 Z' fill='url(#heroFillOsc)' className='hero-osc-fill' />
        </g>

        <path d={HERO_CHART.fillPath} fill='url(#heroFill)' className='animate-fill-hero' />
        <line x1='250' y1='0' x2='250' y2='200' stroke={NOPING_GREEN} strokeWidth='1' strokeDasharray='4 4' opacity='0.5' />
        <text x='255' y='195' fill={NOPING_GREEN} fontSize='10' fontFamily='monospace' opacity='0.7'>
          NoPing ON
        </text>
        <text x='5' y='25' fill='#FF4444' fontSize='9' fontFamily='monospace' opacity='0.6'>
          180ms
        </text>
        <text x='555' y='170' fill={NOPING_GREEN} fontSize='9' fontFamily='monospace' opacity='0.8'>
          2-5ms
        </text>
      </svg>

      <style>{`
        .animate-draw-hero {
          stroke-dasharray: 500;
          stroke-dashoffset: 500;
          animation: drawHero 0.6s ease-out forwards;
        }
        .animate-draw-hero-delayed {
          stroke-dasharray: 700;
          stroke-dashoffset: 700;
          animation: drawHero 0.8s ease-out 0.4s forwards;
        }
        .animate-fill-hero {
          opacity: 0;
          animation: fadeInHero 0.5s ease-out 0.8s forwards;
        }
        @keyframes drawHero {
          to { stroke-dashoffset: 0; }
        }
        @keyframes fadeInHero {
          to { opacity: 1; }
        }
        .hero-osc-line {
          animation: heroOscillate 2s ease-in-out infinite;
        }
        .hero-osc-fill {
          animation: heroOscillate 2s ease-in-out infinite;
        }
        @keyframes heroOscillate {
          0% { d: path("M360,178 L380,176 L400,179 L420,175 L440,178 L460,176 L480,179 L500,175 L520,178 L540,176 L560,179 L580,176 L600,178"); }
          25% { d: path("M360,176 L380,179 L400,175 L420,178 L440,176 L460,179 L480,175 L500,178 L520,176 L540,179 L560,175 L580,178 L600,176"); }
          50% { d: path("M360,175 L380,178 L400,176 L420,179 L440,175 L460,178 L480,176 L500,179 L520,175 L540,178 L560,176 L580,179 L600,175"); }
          75% { d: path("M360,179 L380,175 L400,178 L420,176 L440,179 L460,175 L480,178 L500,176 L520,179 L540,175 L560,178 L580,175 L600,179"); }
          100% { d: path("M360,178 L380,176 L400,179 L420,175 L440,178 L460,176 L480,179 L500,175 L520,178 L540,176 L560,179 L580,176 L600,178"); }
        }
      `}</style>
    </div>
  );
}
